export enum StageType {
  ROUND_ROBIN_1 = 'ROUND_ROBIN_1',
  ROUND_ROBIN_2 = 'ROUND_ROBIN_2',
  SINGLE_ELIMINATION = 'SINGLE_ELIMINATION',
  DOUBLE_ELIMINATION = 'DOUBLE_ELIMINATION',
  GROUP = 'GROUP',
}
